import _ from 'lodash'

/*
* Prepends namespace to every value in an object
*/
export function addNamespace (namespace, types) {
  return _.reduce(types, (typeObj, typeValue, typeName) => {
    typeObj[typeName] = namespace + typeValue
    return typeObj
  }, {})
}
/**
* Creates a reset function that iterates over the state reseting it to the initial state
*
* @param {Object} initState a function to return the initial state
* @returns {function(Object, Object)} a mutation that accepts an array of keys to be ignored by the reset
*   @returns {Object} state - default mutation first parameter
*   @returns {Object} options - ignore options such as ignore fields
*     @returns {Array} options.ignore - ignore array of fields to be ignored
*/

export const reset = (initState) => (state, {ignore} = {ignore: []}) => {
  const preservedState = _.pick(state, ignore)
  const initial = initState()
  _.mapKeys(initial, (value, key) => {
    let shouldPreserve = preservedState[key] !== undefined
    state[key] = shouldPreserve ? preservedState[key] : initial[key]
  })
}

/**
 * @module PersistenceHelper
 * Provides an interface to interact with localStorage
 */
class PersistenceHelper {
  constructor () {
    this._localStorageKey = 'persistenceHelperState'
  }

  _read () {
    const defaultObject = localStorageObject = {
      // could add meta keys here in the future to add support for cache invalidation
      state: {}
    }
    const localStorageVal = localStorage.getItem(this._localStorageKey)

    if (!localStorageVal) return defaultObject

    let localStorageObject
    try {
      localStorageObject = JSON.parse(localStorageVal)
    } catch (error) {
      localStorageObject = defaultObject
    }

    return localStorageObject
  }

  /**
   * writes value to the provided path in localStorage
   * @param {String} key - key/path where the value should be stored.
   * @param {*} value - alue to be stored.
   */
  persist (key, value) {
    const localStorageObject = this._read()
    const state = {
      ...localStorageObject.state
    }
    _.set(state, key, value)

    localStorage.setItem(this._localStorageKey, JSON.stringify({
      ...localStorageObject,
      state
    }))
  }

  /**
   * @param {*} key - key/path to access in localStorage
   * @param {*} defaultVal - value to return if the key/path is not found
   */
  getKey (key, defaultVal) {
    return _.get(this._read().state, key, defaultVal)
  }
}

export const persistenceHelper = new PersistenceHelper()
